import {useQuery} from '@tanstack/react-query';
import logbookApi from '../../api/staffApi/logbookApi';
import MenuApi from '../../api/menuApi/menuApi';

export const useSabitler = () => {
    return useQuery({
        queryKey: ['sabitler'],
        queryFn: () => logbookApi.getSabitler(),
        staleTime: 30 * 60 * 1000, // 30 dakika - Nadir de olsa değişiklikleri yakalamak için
    });
};

export const useFullMenu = () => {
    return useQuery({
        queryKey: ['fullMenu'],
        queryFn: () => MenuApi.getFullMenu(),
    });
};

export const useGunsonu = (tarih: string) => {
    return useQuery({
        queryKey: ['gunsonu', tarih],
        queryFn: () => logbookApi.getGunsonu(tarih),
        enabled: !!tarih,
    });
};
